import Vue from 'vue'

import filters from '.'

Object.keys(filters).forEach((filter) => {
    Vue.filter(filter, filters[filter])
})
